var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.87 16.625C10.7308 16.8649 10.5311 17.0641 10.2907 17.2025C10.0503 17.341 9.77783 17.4139 9.50044 17.4139C9.22306 17.4139 8.95054 17.341 8.71018 17.2025C8.46982 17.0641 8.27004 16.8649 8.13086 16.625",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7486 10.2913C14.3964 9.00204 14.2285 7.66938 14.2499 6.33301",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95583 4.95605C4.81829 5.40225 4.7489 5.86665 4.75 6.33355C4.75 11.8752 2.375 13.4586 2.375 13.4586H13.4583",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 6.33322C14.2508 5.47273 14.0183 4.62805 13.5769 3.88942C13.1354 3.15078 12.5017 2.54593 11.7432 2.13948C10.9848 1.73302 10.1302 1.54023 9.27066 1.58169C8.41117 1.62315 7.57908 1.89731 6.86328 2.37489",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.791992 0.791992L18.2087 18.2087",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribe);
export default __webpack_public_path__ + "static/media/Unsubscribe.a42d744681b4b6d6abb839960fc2cc18.svg";
export { ForwardRef as ReactComponent };